import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import moment from 'moment'
import { Div, P, Loading } from 'konsys-ui'
import { CREATE_INVOICE, UPDATE_INVOICE } from '../../../constants/graphql/mutation'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { GET_SUM_INFO_INVOICE, INVOICE_INFO } from '../../../constants/graphql/query'
import { ActionBar } from '../../../components/invoice-components'
import history from '../../../history'
import { PaidInfo, ShippingLog } from './extension-component'
import { checkCustomerWithCustomRefId } from '../../../utils/util-services'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW
  if (_.isUndefined(props.location.state) && isAddMode) {
    history.push('/invoice')
    return null
  }

  const [mutationVariables, setMutationVariables] = useState(
    isAddMode && {
      jobId: props.location.state.job.jobInfo.id,
      createdDate: moment().format(),
      dueDate: moment().add(props.location.state.job.jobInfo.Customer.credit, 'd').format(),
      shippingId: _.map(props.location.state.shippingOrders, v => v.id),
      feeRate: props.location.state.job.jobInfo.feeRate,
      pricePerLitre: !_.isNull(props.location.state.job.jobInfo.predealPrice) ? props.location.state.job.jobInfo.predealPrice : 0,
      revenueRecordDate: props.location.state.shippingOrders.map(v => v.deliveryDate).reduce((accumulator, currentValue) => (moment(accumulator).isAfter(currentValue) ? accumulator : currentValue), props.location.state.shippingOrders[0].deliveryDate),
    },
  )


  let onChangeHandler = (id, value) => {
    if (id === 'createdDate') {
      setMutationVariables({
        ...mutationVariables,
        dueDate: moment(value).add(props.location.state.job.jobInfo.Customer.credit, 'd').format(),
        [id]: value,
      })
    } else {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
      })
    }
  }
  const createData = isAddMode ? {
    ...props.location.state.job.jobInfo.Customer,
    ...props.location.state.job.jobInfo,
    totalCount: props.location.state.shippingOrders.length,
    totalWeight: props.location.state.shippingOrders.map(v => v.totalWeight).reduce((accumulator, currentValue) => accumulator + currentValue),
    customerId: props.location.state.job.jobInfo.Customer.id,
    branch: props.location.state.job.jobInfo.Customer.branch,
    credit: props.location.state.job.jobInfo.Customer.credit,
    groupId: props.location.state.job.jobInfo.Customer.groupId,
    shippingCount: props.location.state.shippingOrders.length,
    shippingGrandTotal: props.location.state.shippingOrders.map(v => v.feeTotal).reduce((accumulator, currentValue) => accumulator + currentValue),
  } : {}
  let initialData = {}
  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? <Div>
            {
              detailType(props.match.params,
                onChangeHandler,
                mutationVariables,
                {
                  ...createData,
                  shippingUnit: props.location.state.shippingOrders[0].unit,
                  feeRate: props.location.state.job.jobInfo.feeRate,
                  pricePerLitre: props.location.state.job.jobInfo.predealPrice,
                })
            }
            {
              !_.isEmpty(props.location.state.shippingOrders)
                && <ShippingLog data={{
                  shippings: props.location.state.shippingOrders,
                  jobDealType: props.location.state.job.jobInfo.dealType,
                  jobUnit: props.location.state.job.jobInfo.unit,
                  isMithrGroup: props.location.state.job.jobInfo.Customer.groupId === 6,
                }}/>
            }
              <Mutation
                mutation={CREATE_INVOICE}
              >
              {(doAction, { loading }) => (
                <ActionBar
                  loading={loading}
                  disabled={
                    (
                    //   _.isUndefined(mutationVariables.volume) || _.isNaN(mutationVariables.volume)
                    // || _.isUndefined(mutationVariables.number) || _.isNaN(mutationVariables.number)
                    (checkCustomerWithCustomRefId(createData) && (_.isUndefined(mutationVariables.customerRefId) || _.isEmpty(mutationVariables.customerRefId)))
                    || mutationVariables.createdDate === 'Invalid date'
                    || mutationVariables.dueDate === 'Invalid date'
                    || !moment(mutationVariables.dueDate).isAfter(moment(mutationVariables.createdDate)))
                  } // condition here
                  isAddMode={isAddMode}
                  isViewMode={isViewMode}
                  doAction={doAction}
                  mutationVariables={{ ...mutationVariables }}
                  props={props}
                  groupId={createData.groupId}
                />
              )}
              </Mutation>
            </Div>
          : <Query
              query={INVOICE_INFO}
              variables={{
                id: props.match.params.id,
              }}
            >
              {
                ({
                  data: invoice, error: invoiceError, loading: invoiceLoading,
                }) => {
                  if (invoiceLoading && _.isEmpty(invoice)) return <Loading />
                  if (invoiceError) return <P>เกิดข้อผิดพลาด</P>
                  return (
                    <Div>
                      <Query
                        query={GET_SUM_INFO_INVOICE}
                        variables={{
                          id: _.map(invoice.InvoiceInfo.shippings, v => v.id),
                          invoiceId: parseInt(props.match.params.id, 10),
                        }}
                      >
                        {
                          ({ data: sum, error: sumError, loading: sumLoading }) => {
                            if (sumLoading && _.isEmpty(invoice)) return <Loading />
                            if (sumError) return <P>เกิดข้อผิดพลาด</P>
                            initialData = {
                              ...invoice.InvoiceInfo,
                              customerId: invoice.InvoiceInfo.Job.customerId,
                              dealType: invoice.InvoiceInfo.Job.dealType,
                              unit: invoice.InvoiceInfo.Job.unit,
                              companyName: !_.isNull(invoice.InvoiceInfo.Job.Customer) && invoice.InvoiceInfo.Job.Customer.companyName,
                              groupId: !_.isNull(invoice.InvoiceInfo.Job.Customer) && invoice.InvoiceInfo.Job.Customer.groupId,
                              branch: !_.isNull(invoice.InvoiceInfo.Job.Customer) && invoice.InvoiceInfo.Job.Customer.branch,
                              cargo: invoice.InvoiceInfo.Job.cargo,
                              contractWeight: invoice.InvoiceInfo.Job.contractWeight,
                              deliveredWeight: invoice.InvoiceInfo.Job.deliveredWeight,
                              credit: invoice.InvoiceInfo.Job.Customer.credit,
                              customerRefId: invoice.InvoiceInfo.customerRefId,
                              shippingCount: invoice.InvoiceInfo.shippings.length,
                              ...sum.calculateDeliveredShipping,
                            }
                            onChangeHandler = (id, value) => {
                              if (checkCustomerWithCustomRefId(initialData)) {
                                setMutationVariables({
                                  customerRefId: invoice.InvoiceInfo.customerRefId,
                                  volume: initialData.volume,
                                  number: initialData.number,
                                  createdDate: initialData.createdDate,
                                  dueDate: initialData.dueDate,
                                  feeRate: initialData.feeRate,
                                  ...mutationVariables,
                                  [id]: id === 'volume' || id === 'number' ? parseInt(value, 10) : value,
                                })
                              } else {
                                setMutationVariables({
                                  volume: initialData.volume,
                                  number: initialData.number,
                                  createdDate: initialData.createdDate,
                                  dueDate: initialData.dueDate,
                                  feeRate: initialData.feeRate,
                                  ...mutationVariables,
                                  [id]: id === 'volume' || id === 'number' ? parseInt(value, 10) : value,
                                })
                              }
                            }
                            return (
                              <Div>
                              {
                                detailType(props.match.params, onChangeHandler, mutationVariables, initialData)
                              }
                                {
                                  (invoice.InvoiceInfo.status === 'PAID' || invoice.InvoiceInfo.status === 'PARTIAL')
                                    && <PaidInfo
                                          invoice={invoice}
                                          isViewMode={isViewMode}
                                          // onChangeHandler={onChangeHandler}
                                          // mutationVariables={mutationVariables}
                                          // setMutationVariables={setMutationVariables}
                                        />
                                }
                                {
                                  !_.isEmpty(invoice.InvoiceInfo.shippings)
                                    && <ShippingLog data={{
                                      ...invoice.InvoiceInfo,
                                      jobDealType: invoice.InvoiceInfo.Job.dealType,
                                      jobUnit: invoice.InvoiceInfo.Job.unit,
                                      isMithrGroup: invoice.InvoiceInfo.Job.Customer.groupId === 6,
                                    }}/>
                                }
                                {
                                  !isViewMode
                                    ? <Mutation
                                        mutation={isAddMode ? CREATE_INVOICE : UPDATE_INVOICE}
                                        refetchQueries={['InvoiceInfo', 'calculateDeliveredShipping']}
                                      >{(doAction, { loading }) => (
                                        <ActionBar
                                          loading={loading}
                                          disabled={
                                            (
                                            //   _.isUndefined(mutationVariables.volume) || _.isNaN(mutationVariables.volume)
                                            // || _.isUndefined(mutationVariables.number) || _.isNaN(mutationVariables.number)
                                            // ||
                                              (checkCustomerWithCustomRefId(initialData) && (_.isUndefined(mutationVariables.customerRefId) || _.isNaN(mutationVariables.customerRefId)))
                                            || _.isUndefined(mutationVariables.createdDate) || mutationVariables.createdDate === 'Invalid date'
                                            || _.isUndefined(mutationVariables.dueDate) || mutationVariables.dueDate === 'Invalid date'
                                            || !moment(mutationVariables.dueDate).isAfter(moment(mutationVariables.createdDate)))
                                            && (!isAddMode && _.isUndefined(mutationVariables.bank)
                                            && _.isUndefined(mutationVariables.customerBankFees)
                                            && _.isUndefined(mutationVariables.withHoldingTax))
                                          } // condition here
                                          isAddMode={isAddMode}
                                          isViewMode={isViewMode}
                                          doAction={doAction}
                                          mutationVariables={{ ...mutationVariables }}
                                          props={{
                                            ...props,
                                            ...sum.calculateDeliveredShipping,
                                          }}
                                          customerId={initialData.customerId.toString()}
                                          dealType={initialData.dealType}
                                          unit={initialData.unit}
                                          invoice={invoice.InvoiceInfo}
                                          groupId={initialData.groupId}

                                        />
                                      )}
                                      </Mutation>
                                    : <ActionBar
                                        isAddMode={isAddMode}
                                        isViewMode={isViewMode}
                                        props={{
                                          ...props,
                                          ...sum.calculateDeliveredShipping,
                                        }}
                                        customerId={initialData.customerId.toString()}
                                        dealType={initialData.dealType}
                                        unit={initialData.unit}
                                        invoice={invoice.InvoiceInfo}
                                        groupId={initialData.groupId}

                                      />
                                }
                              </Div>
                            )
                          }
                        }
                      </Query>
                    </Div>
                  )
                }
              }
            </Query>
      }
    </Div>
  )
}

export default Index
export { Index }
